var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      staticClass:
        "document-download-link d-inline-flex align-center link-decoration-none primary--text",
      attrs: {
        download: "",
        href: _vm.href,
        "data-qa": "document_download_link",
      },
    },
    [
      _c("span", {
        staticClass:
          "ui-icon-download-arrow ui-icon-fz-medium text-secondary--text mr-1",
      }),
      _vm._v(" "),
      _c("span", { staticClass: "text-body-2" }, [_vm._v(_vm._s(_vm.label))]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }